const HoseIcon = ({ strokeColor = '#808080' }) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 795.1 795.1"
  >
    <defs>
      <style>{`
        .cls-1 {
          fill: #fcfcfc;
        }
        .cls-2 {
          fill: #4d4d4d;
        }
        .cls-3 {
          stroke: ${strokeColor};
          stroke-width: 50px;
        }
        .cls-3, .cls-4 {
          fill: none;
          stroke-miterlimit: 10;
        }
        .cls-4 {
          stroke: #fff;
          stroke-width: 20px;
        }
        .cls-5 {
          fill: #fdfdfd;
        }
      `}</style>
    </defs>
    <g id="Circles">
      <circle id="Grey_Bkg" className="cls-2" cx="397.55" cy="397.55" r="388.66" />
      <circle id="Grey" className="cls-3" cx="397.55" cy="397.55" r="372.55" />
      <circle id="White_Inner" className="cls-4" cx="397.55" cy="397.55" r="343.4" />
    </g>
    <g id="Shapes">
      <g id="Hose">
        <g id="Layer_1-2" data-name="Layer 1-2">
          <path
            className="cls-5"
            d="M641.29,444.47c1.82,4.64,4.14,8.77,4.26,12.96.45,16.07.23,32.16.18,48.25-.03,11.78-5.79,17.55-17.44,17.64-3.94.03-7.88,0-11.11,0-4.79,12.74-8.28,25.68-14.3,37.32-14.83,28.63-39.19,45.8-71.03,48.67-29.11,2.62-58.57.96-87.84,2.19-49.1,2.06-94.57-11.24-138.57-31.23-22.02-10-45.15-18.42-65.42-31.27-50.05-31.72-79.87-78.42-88.47-136.81-15.38-104.36,48.31-198.51,151.23-223.35,106.22-25.63,215.05,41.97,237.96,147.83,14.63,67.6.19,128.06-46.06,179.85-28.49,31.9-64.84,50.93-106.8,61.74,9.38,1.42,18.74,3.93,28.14,4.07,34.7.5,69.46,1.31,104.11-.08,34.73-1.4,61.51-23.88,64.37-58.38-26.51-2.6-26.96-3.11-26.96-29.95,0-12.13-.66-24.32.32-36.38.41-5.01,3.18-11.18,6.97-14.15,3.46-2.71,4.43-4.72,4.4-8.54-.11-12.98-.09-25.96.06-38.94.12-10.49,6.27-16.42,16.9-16.48,11.29-.07,22.58-.08,33.86,0,10.98.08,17.03,6.2,17.07,17.2.05,12.98-.2,25.97.18,38.94.08,2.85,2.27,5.63,4,8.91M407.27,223.78c-30-10.36-60.44-13.08-91.87-7.15-91.47,17.26-154.45,108.61-131.12,206.58,21,88.15,108.77,144.44,200.88,123.92,86.48-19.26,143.34-103.11,129.54-189.51-10.18-63.69-46.13-108.52-107.43-133.84M599.1,494.87h17.71v-25.1h-29.88v25.1c3.79,0,7.14,0,12.16,0M607.51,407.83h-10.29v33.77h11.09c0-11.09,0-21.7-.81-33.77h0Z"
          />
          <path
            className="cls-1"
            d="M424.07,496.54c-64.33,41.67-149.14,24.55-190.46-38.02-41.54-62.9-24.52-147.72,38.14-190.12,61.66-41.72,147.53-25.26,189.58,36.34,42.91,62.87,26.67,147.53-37.27,191.79M261.85,447.32c26.62,33.89,61.88,48.2,103.92,41.63,62.36-9.75,96.37-70.42,88.91-121.19-8.93-60.78-67.33-103.68-127.45-91.39-77.2,15.77-112.14,105.67-65.37,170.96h0Z"
          />
          <path
            className="cls-5"
            d="M413.57,419.78c-25.07,41.78-74.82,47.86-108.29,25.16-25.98-17.62-38.32-50.75-30.35-82.19,7.21-28.5,33.54-50.65,63.47-54.73,47.39-6.47,89.04,32.62,84.96,80.43-.89,10.44-6.29,20.5-9.79,31.34M313.69,351.47c-13.4,16.2-15.88,35.98-6.63,53.04,9.51,17.56,26.72,26.17,47.89,23.95,22.73-2.38,43.34-28.27,39.77-50.33-3.05-18.85-13-33.01-31.41-38.9-17.97-5.75-34.85-2.46-49.62,12.23h0Z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default HoseIcon;